// See library of custom components in doc-site to steal from https://github.rbx.com/Roblox/creator-doc-site/blob/master/services/doc-site-ssr/app/modules/ui/markdown/constants/aliasComponents.tsx
// Aliases for native markdown components
import Markdown from '../components/Markdown';

const getMarkdownComponents = ({
  onAnchorClickLoggedParams,
}: {
  onAnchorClickLoggedParams: Record<string, string>;
}) => ({
  h1: Markdown.H1,
  h2: Markdown.H2,
  h3: Markdown.H3,
  h4: Markdown.H4,
  h5: Markdown.H5,
  h6: Markdown.H6,
  p: Markdown.P,
  a: Markdown.A(onAnchorClickLoggedParams),
  code: Markdown.Code,
  pre: Markdown.Pre,
});

export default getMarkdownComponents;
